import { Link } from "react-router-dom";
import "./details-table.scss";

const DetailsTable = ({ data }) => {
  return (
    <div className="details-table-container">
      <table className="details-table">
        {data.map((ele) => (
          <tr>
            <th>{ele.title}</th>
            <td>
              {ele.isLink ? (
                <Link to={ele.link}>{ele.desc}</Link>
              ) : (
                <p>{ele.desc}</p>
              )}
            </td>
          </tr>
        ))}
      </table>
    </div>
  );
};
export default DetailsTable;
